import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {VIEW_STATE} from "../utils/enums";

const slice = createSlice({
    name: 'userCategory',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        userCategories: []
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setUserCategories: (state, action) => {
            state.userCategories = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
    },
});

export default slice.reducer
const {setViewState, setUserCategories} = slice.actions

export const getUserCategories = () => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.userCategory.get()
        dispatch(setUserCategories(data.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
